// Render only the selected social format's verified API options.
// Values remain local to one saved variation; schemas and validation are shared
// with publishing, while unimplemented formats remain explicitly draft-only.
import React from "react";

export default function PromotionPostOptions({ capabilities, value = {}, onChange, disabled = false }) {
  if (!capabilities?.supported || !capabilities.fields.length) return null;
  const change = (key, next) => {
    const updated = { ...value };
    if (next === "" || next === undefined || (Array.isArray(next) && next.every((item) => !item.trim()))) delete updated[key];
    else updated[key] = next;
    onChange(updated);
  };
  return <fieldset className="border rounded p-3 mb-3" disabled={disabled}>
    <legend className="float-none w-auto px-2 fs-6">Additional Post Options</legend>
    <p className="form-text mt-0">Optional settings for this Platform and Post Type. Text overlays, native effects and music choices are not enabled unless supported here.</p>
    {capabilities.fields.map((field) => {
      const id = `promotion-option-${field.key}`;
      if (field.type === "boolean") return <div className="form-check mb-3" key={field.key}>
        <input id={id} className="form-check-input" type="checkbox" checked={value[field.key] === true}
          aria-describedby={field.help ? `${id}-help` : undefined}
          onChange={(event) => change(field.key, event.target.checked)} />
        <label className="form-check-label" htmlFor={id}>{field.label}</label>
        {field.help && <div id={`${id}-help`} className="form-text">{field.help}</div>}
      </div>;
      const props = { id, className: "form-control", value: value[field.key] ?? "",
        "aria-describedby": field.help ? `${id}-help` : undefined,
        onChange: (event) => change(field.key, field.type === "integer" && event.target.value !== "" ? Number(event.target.value) : event.target.value) };
      return <div className="mb-3" key={field.key}>
        <label className="form-label" htmlFor={id}>{field.label}</label>
        {field.options ? <select {...props} className="form-select" onChange={(event) => {
          const option = field.options.find((item) => String(typeof item === "object" ? item.value : item) === event.target.value);
          change(field.key, option === undefined ? "" : typeof option === "object" ? option.value : option);
        }}><option value="">Not set</option>{field.options.map((option) => {
          const optionValue = typeof option === "object" ? option.value : option;
          return <option key={optionValue} value={optionValue}>{typeof option === "object" ? option.label : option}</option>;
        })}</select> : field.type === "stringArray" ? <textarea {...props} rows={3}
          value={Array.isArray(value[field.key]) ? value[field.key].join("\n") : ""}
          onChange={(event) => change(field.key, event.target.value.split(/\r?\n/))} />
          : <input {...props} type={field.type === "integer" ? "number" : field.type === "url" ? "url" : "text"}
            min={field.min} max={field.max} step={field.type === "integer" ? 1 : undefined} maxLength={field.maxLength} />}
        {field.help && <div id={`${id}-help`} className="form-text">{field.help}</div>}
      </div>;
    })}
    {capabilities.docsUrl && <a href={capabilities.docsUrl} target="_blank" rel="noopener noreferrer">Platform API details</a>}
  </fieldset>;
}
